import {computed, makeObservable} from "mobx";
import SaporeForm from "../forms/SaporeForm";
import FileField from "../forms/fields/FileField";
import TextField from "../forms/fields/TextField";

export default class FinanceDataForm extends SaporeForm {
    static newEmpty(feature = null, configuration) {
        const initialData = {
            financeObservations: null,
            nosisDocument: null,
        };
        return new FinanceDataForm(initialData, feature, configuration);
    }

    static newFor(initialData = null, feature = null, configuration) {
        return new FinanceDataForm(initialData || {}, feature, configuration);
    }

    constructor(initialData = {}, feature = null, configuration) {
        const form = super({}, null, feature, configuration);

        const fields = {
            financeObservations: new TextField(1, 4096, this.isOptional('financeObservations'), initialData.financeObservations, feature),
            nosisDocument: new FileField(0, 1, this.isOptional('nosisDocument'), initialData.nosisDocument, feature),
        };

        form.setFields(fields);

        makeObservable(this, {
            financeObservationsValue: computed,
            nosisDocumentValue: computed,
        });
    }

    configurationFieldNameMapping() {
        return {
            financeObservations: '_finance_observations',
            nosisDocument: '_nosis_document',
        }
    }

    financeObservations() {
        return this.getFieldByName('financeObservations').value;
    }

    nosisDocument() {
        return this.getFieldByName('nosisDocument').value;
    }

    get financeObservationsValue() {
        return this.financeObservations()
    }

    get nosisDocumentValue() {
        return this.nosisDocument()
    }


}
